import { render, staticRenderFns } from "./TeamGallery.vue?vue&type=template&id=0fa6652d&"
import script from "./TeamGallery.vue?vue&type=script&lang=js&"
export * from "./TeamGallery.vue?vue&type=script&lang=js&"
import style0 from "./TeamGallery.vue?vue&type=style&index=0&id=0fa6652d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports